import routes from "../../capiRoutes";
import raw from "../../rawClients/rawCapiClient";
export default {
  getAllInProject(projectUid) {
    return raw.getAll(routes.rfis.allInProject(projectUid));
  },
};
